---
date: 2022-01-15
title: Preview IMDF files
---

You can new preview [Indoor Mapping Data Format (IMDF)](https://register.apple.com/resources/imdf/) files.
